module.exports = __webpack_public_path__ + "static/img/MainLogoWhite -arrow-white2.ecf2cd6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medias/images/MainLogoWhite -arrow-white2.svg
// module id = lriX
// module chunks = 1